<script>
/**
 * 数字滚动（自 vancheen-b2b 的 CountUp.vue 移植为 Vue 2 版本）
 * IntersectionObserver(threshold 0.4) 进入视口 → requestAnimationFrame
 * 1600ms + easeOutCubic 缓动 → toLocaleString() + 后缀
 */
export default {
  name: 'NhCountUp',
  props: {
    value: { type: Number, required: true },
    suffix: { type: String, default: '' }
  },
  data() {
    return {
      text: String(this.value) + this.suffix
    }
  },
  mounted() {
    if (!('IntersectionObserver' in window)) {
      this.finish()
      return
    }
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return
          this.play()
          this.observer.unobserve(entry.target)
        })
      },
      { threshold: 0.4 }
    )
    this.observer.observe(this.$el)
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
    if (this.raf) cancelAnimationFrame(this.raf)
  },
  methods: {
    play() {
      const DURATION = 1600
      const easeOutCubic = p => 1 - Math.pow(1 - p, 3)
      let start = null
      const step = ts => {
        if (!start) start = ts
        const p = Math.min((ts - start) / DURATION, 1)
        this.text = Math.round(this.value * easeOutCubic(p)).toLocaleString() + this.suffix
        if (p < 1) this.raf = requestAnimationFrame(step)
      }
      this.raf = requestAnimationFrame(step)
    },
    finish() {
      this.text = this.value.toLocaleString() + this.suffix
    }
  }
}
</script>

<template>
  <span>{{ text }}</span>
</template>
